/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { type Quote } from '../../../../../modules/quotes'
import { type PromoCode } from '../../../../../modules/promoCodes'
import { ignoreTimezone } from '../../../../../utils/date'
import { mergeClassName } from '../../../../../utils/mergeClassName'
import AlternativeDate from './AlternativeDate'
import DateBox from './DateBox'
import { useGetSubtotalWithPromoCode } from '../../../../../modules/promoCodes/core/promoCodes.utils'

type AlternativeDatesProps = {
  quote: Quote
  promoCode?: PromoCode
  className?: string
}

const AlternativeDates: React.FC<AlternativeDatesProps> = ({
  quote,
  promoCode,
  className,
}) => {
  const priceWithPromoCode = useGetSubtotalWithPromoCode()

  const alternativeDates = quote.alternativeDates
  if (!alternativeDates?.length) {
    return null
  }

  const before = alternativeDates.filter(date => new Date(date.date) < new Date(quote.date))
  const after = alternativeDates.filter(date => new Date(date.date) > new Date(quote.date))

  return (
    <div className={mergeClassName(
      'flex flex-wrap gap-1 justify-center sm:justify-normal',
      'max-h-[134px] overflow-hidden',
      className,
    )}
    >
      { before.map(alternativeDate => (
        <AlternativeDate
          key={new Date(alternativeDate.date).getTime()}
          alternativeDate={alternativeDate}
          quote={quote}
          promoCode={promoCode}
        />
      )) }

      <DateBox
        current
        date={ignoreTimezone(quote.date)!}
        price={priceWithPromoCode(quote.subtotal, promoCode).price}
      />

      { after.map(alternativeDate => (
        <AlternativeDate
          key={new Date(alternativeDate.date).getTime()}
          alternativeDate={alternativeDate}
          quote={quote}
          promoCode={promoCode}
        />
      )) }

    </div>
  )
}

export default AlternativeDates
